import { tableOrderMapper } from '../clerk-orders-overview/transform_raw_data_to_orders_table_format';

const ORDER_TYPE_LABELS = {
  zaehlereinbau: 'Einbau',
  zaehlerausbau: 'Ausbau',
  zaehlerwechsel: 'Wechsel',
};

export function getCommissioningOrderType(order = {}) {
  return order.order_type || order.payload?.order_type;
}

export function commissioningTableOrderMapper(order) {
  const mappedOrder = tableOrderMapper(order);
  const reasonLabel = ORDER_TYPE_LABELS[getCommissioningOrderType(order)];

  if (!mappedOrder.product || !reasonLabel) {
    return mappedOrder;
  }

  return {
    ...mappedOrder,
    product: `${mappedOrder.product} ${reasonLabel}`,
  };
}
